<template lang="pug">
.error-500.text-large
  .error-500__message 500エラーが発生しました。
  a(:href='topPage') 戻る
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Error500 extends Vue {
  private get topPage(): string {
    return this.$bcbtCookies.returnUrl.get()
  }
}
</script>

<style lang="stylus" scoped>
.error-500
  margin 50px

  &__message
    margin-bottom 20px
</style>
